import { render } from "./clipboardTextarea.vue?vue&type=template&id=e8a84fa6"
import script from "./clipboardTextarea.vue?vue&type=script&lang=js"
export * from "./clipboardTextarea.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__